import React, { useCallback } from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody, Row } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ValidDates } from '@/components/changeRequests/common/validDates'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { ChangeItemFileAttachments } from '@/components/changeRequests/fileAttachments'

function BanDialog (props) {
  const getAttachmentsTableData = useCallback((req) => context.api.individualService.getBanAttachmentsTableData(props.id, req), [props.id])
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Individuals.Ban' {...props} />
        <ModalBody>
          <Row>
            <div className='col-12'>
              <FormRow label='Individuals.BanType' name='type' target={props.target} inputType='lookup' dataSource={context.cache.getBanTypes} clientSide isCodeList />
              <ValidDates target={props.target} />
            </div>
          </Row>
          <Row>
            <div className='col-12'>
              <ChangeItemFileAttachments
                target={props.target}
                name='attachments'
                dataSource={getAttachmentsTableData}
                downloadAction={context.api.individualService.downloadBanAttachment}
                simpleView
                attachmentsView />
            </div>
          </Row>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  component: BanDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/ban.js